const config = {
  MAPBOX_API_ACCESS_TOKEN:
    'pk.eyJ1IjoiZ2xvYmFsYnVpbGRzb2x1dGlvbnMiLCJhIjoiY2tqeXAzcnp3MDZ6cTJvczE0ZDMybmVmNSJ9.A9Lsmzq00b3ek1HMty1W-g',
  MAPBOX_STANDARD_MAP_V1: 'globalbuildsolutions/ckmffyvup0xdi17p83wxiv171',
  MAPBOX_SAT_MAP_V1: 'globalbuildsolutions/cl31kvkvq000415mntx5b7e2u',
  MAPBOX_OUTDOORS_MAP_V1: 'globalbuildsolutions/cloh8hl90000c01peej0b3rxx',
};

export default config;
